// extracted by mini-css-extract-plugin
module.exports = {"edit_sort_input":"edit_sort_input___359jN","input":"input___3BOBi","label":"label___1L9CT","confirm":"confirm___EYkJS","close":"close___3FvJd","edit":"edit___3KJMC"};